/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { ISchemaIntegrationRefModel, TGenericModelNode } from "@adapptio/lib-blueprint";
import { IInspectorControls, TInspectorControlComponent } from "../InspectorTypes";
import { useBlueprintModel } from "../../../hooks/useBlueprintModel";
import { InvalidModelNode } from "../InvalidModelNode";
import { InspectModel } from "../InspectModel";

export const ControlIntegrationRef_Children: TInspectorControlComponent<ISchemaIntegrationRefModel> = ({
	model: _model,
	path,
	depth
}) => {
	const { model } = useBlueprintModel(_model, "integrationRef");
	const { model: paramsModel } = useBlueprintModel(_model?.params);

	if (!model) {
		return <InvalidModelNode model={_model} />;
	}

	return (
		<>
			<InspectModel model={paramsModel} path={path.concat([ "params" ])} depth={depth} />
		</>
	);
};

export const ControlIntegrationRef = (model: TGenericModelNode): IInspectorControls => ({
	children: {
		component: ControlIntegrationRef_Children,
		model: model
	}
	// displayInSection: true
});
